var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneticsOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.03 25.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-genetics-orange{fill:#f9b093;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6117",
    "data-name": "Group 6117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6115",
    "data-name": "Group 6115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_22526",
    "data-name": "Path 22526"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M14.74,22.17h-.38c0-1.69,1.19-3.31,3.57-4.86,2.14-1.4,3.32-3,3.31-4.44s-1.17-3.09-3.31-4.48c-2.37-1.55-3.58-3.18-3.57-4.83a.39.39,0,0,1,.38-.4h0a.37.37,0,0,1,.38.37v0c0,1.38,1.08,2.78,3.23,4.18C20.72,9.28,22,11.09,22,12.82S20.72,16.41,18.36,18c-2.15,1.39-3.23,2.8-3.23,4.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22527",
    "data-name": "Path 22527"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M21.63,22.54h0a.38.38,0,0,1-.39-.37c0-1.41-1.07-2.82-3.22-4.21-2.37-1.55-3.67-3.35-3.66-5.09S15.65,9.28,18,7.74c2.14-1.4,3.23-2.8,3.22-4.18l.39,0,.39,0c0,1.65-1.2,3.28-3.58,4.83-2.14,1.39-3.31,3-3.3,4.43s1.16,3.09,3.3,4.49C20.82,18.86,22,20.48,22,22.14A.41.41,0,0,1,21.63,22.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22528",
    "data-name": "Path 22528"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M18.19,18a.37.37,0,0,1-.21-.06c-2.35-1.54-3.63-3.34-3.62-5.07S15.63,9.3,18,7.77a.36.36,0,0,1,.42,0C20.74,9.3,22,11.1,22,12.83l-.39,0,.39,0c0,1.73-1.28,3.53-3.62,5.07A.39.39,0,0,1,18.19,18Zm0-9.44c-2,1.35-3.07,2.86-3.06,4.27s1.08,3,3.06,4.32c2-1.35,3.06-2.86,3-4.27v-.05C21.25,11.42,20.17,9.91,18.19,8.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1459",
    "data-name": "Line 1459"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M18.19,3.91H14.74a.39.39,0,0,1,0-.77h3.45a.39.39,0,0,1,0,.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1460",
    "data-name": "Line 1460"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M18.19,5h-2.3a.39.39,0,0,1,0-.78h2.3a.39.39,0,0,1,0,.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1461",
    "data-name": "Line 1461"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M18.19,6.1H16.71a.39.39,0,1,1,0-.77h1.48a.39.39,0,1,1,0,.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1462",
    "data-name": "Line 1462"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M21.6,22.56H18.15a.39.39,0,0,1,0-.77H21.6a.39.39,0,0,1,0,.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1463",
    "data-name": "Line 1463"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M20.45,21.47h-2.3a.39.39,0,0,1,0-.78h2.3a.39.39,0,0,1,0,.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1464",
    "data-name": "Line 1464"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M19.63,20.37H18.15a.39.39,0,0,1,0-.77h1.48a.39.39,0,1,1,0,.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1465",
    "data-name": "Line 1465"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M19.45,13.24H16.93a.39.39,0,0,1,0-.78h2.52a.39.39,0,0,1,0,.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1466",
    "data-name": "Line 1466"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M19,12.18H17.4a.39.39,0,1,1,0-.77H19a.39.39,0,1,1,0,.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_1467",
    "data-name": "Line 1467"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M19,14.3H17.4a.39.39,0,0,1,0-.78H19a.39.39,0,0,1,0,.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22529",
    "data-name": "Path 22529"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M9.39,17.46A4.49,4.49,0,0,1,7.49,17a.37.37,0,0,1-.21-.26.37.37,0,0,1,.06-.32l.3-.4a1.29,1.29,0,0,1,.67-.48.92.92,0,0,1,.28-.05,1.37,1.37,0,0,1,.6.07.49.49,0,0,0,.22.05.65.65,0,0,0,.19,0,1.4,1.4,0,0,1,.6-.07,1.37,1.37,0,0,1,.35.08,1.42,1.42,0,0,1,.57.43l.31.41a.37.37,0,0,1,.06.32.35.35,0,0,1-.21.26A4.48,4.48,0,0,1,9.39,17.46Zm-1.12-.94a3.69,3.69,0,0,0,2.23,0,.61.61,0,0,0-.24-.18.28.28,0,0,0-.13,0,.71.71,0,0,0-.3,0,2.13,2.13,0,0,1-.44.07A1.19,1.19,0,0,1,9,16.34a.68.68,0,0,0-.3,0H8.54A.56.56,0,0,0,8.27,16.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22530",
    "data-name": "Path 22530"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M9.72,18.61H9a1.64,1.64,0,0,1-.64-.18l-.49-.37a.39.39,0,0,1,.47-.61l.43.33a1.7,1.7,0,0,0,.26,0h.85a.68.68,0,0,0,.31-.11l.33-.26a.37.37,0,0,1,.54.06.38.38,0,0,1-.06.54l-.37.3a1.76,1.76,0,0,1-.63.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22531",
    "data-name": "Path 22531"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M9.31,14.62a1.51,1.51,0,0,1-.8-.22l-.22-.15c-.2-.13-.34-.22-.4-.45a.37.37,0,0,1,.27-.47.38.38,0,0,1,.47.26c0-.05,0,0,.09,0l.2.14a.8.8,0,0,0,.82,0l.19-.12.1-.07a.4.4,0,0,1,.44-.22.39.39,0,0,1,.29.47.77.77,0,0,1-.41.46l-.19.13A1.66,1.66,0,0,1,9.31,14.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22532",
    "data-name": "Path 22532"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M6,11.12a2.33,2.33,0,0,1-.53-.06,2.36,2.36,0,0,1-1-.53.47.47,0,0,0-.55,0,.39.39,0,1,1-.47-.61A1.23,1.23,0,0,1,5,9.94a1.67,1.67,0,0,0,.71.37,1.45,1.45,0,0,0,.55,0A4,4,0,0,0,7,10.14L7.57,10a.39.39,0,0,1,.48.26.4.4,0,0,1-.27.48l-.52.15a4.77,4.77,0,0,1-.94.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22533",
    "data-name": "Path 22533"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M4.77,11.45a.38.38,0,0,1-.34-.57,1.19,1.19,0,0,1,.94-.63.37.37,0,0,1,.42.35.38.38,0,0,1-.35.42.43.43,0,0,0-.33.22A.39.39,0,0,1,4.77,11.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22532-2",
    "data-name": "Path 22532"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M12.66,11.12a2.35,2.35,0,0,0,1.56-.59.47.47,0,0,1,.55,0,.39.39,0,1,0,.47-.61,1.23,1.23,0,0,0-1.51,0,1.77,1.77,0,0,1-.72.37,1.4,1.4,0,0,1-.54,0,4.05,4.05,0,0,1-.82-.19L11.12,10a.39.39,0,0,0-.48.26.39.39,0,0,0,.27.48l.51.15a4.87,4.87,0,0,0,.95.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22533-2",
    "data-name": "Path 22533"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M13.92,11.45a.33.33,0,0,0,.17,0,.4.4,0,0,0,.17-.53,1.21,1.21,0,0,0-.94-.63.37.37,0,0,0-.42.35.38.38,0,0,0,.34.42.41.41,0,0,1,.33.22A.4.4,0,0,0,13.92,11.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22535",
    "data-name": "Path 22535"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M9.32,21.63a2.87,2.87,0,0,1-1.7-.55C5.5,19.59,2.84,17.3,2.21,14.92a.39.39,0,0,1,.75-.2c.6,2.27,3.46,4.57,5.11,5.73a2.13,2.13,0,0,0,2.5,0c.66-.46,1.27-.93,1.84-1.41a.38.38,0,0,1,.54,0,.39.39,0,0,1,0,.55c-.58.49-1.22,1-1.89,1.45A2.87,2.87,0,0,1,9.32,21.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22536",
    "data-name": "Path 22536"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M7.65,8.68a.42.42,0,0,1-.29-.12A1.75,1.75,0,0,0,6.28,8,7.08,7.08,0,0,0,4.33,8a.39.39,0,0,1-.11-.77,7.89,7.89,0,0,1,2.17,0A2.58,2.58,0,0,1,7.94,8a.38.38,0,0,1,0,.54A.37.37,0,0,1,7.65,8.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22537",
    "data-name": "Path 22537"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M10.45,8.67a.43.43,0,0,1-.26-.09.39.39,0,0,1,0-.55,2.58,2.58,0,0,1,1.54-.83,8.05,8.05,0,0,1,2.55.17.38.38,0,0,1,.29.46.38.38,0,0,1-.46.29A7.34,7.34,0,0,0,11.8,8a1.84,1.84,0,0,0-1.06.58A.4.4,0,0,1,10.45,8.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22538",
    "data-name": "Path 22538"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-genetics-orange",
    d: "M5.5,22.32a.37.37,0,0,1-.32-.17C-.73,13.67,2.93,6.59,5.68,4c1.76-1.7,4.17-1.59,6.62-1.48a.38.38,0,0,1,.37.4.4.4,0,0,1-.4.37C10,3.22,7.83,3,6.22,4.59c-2.6,2.41-6,9.07-.41,17.12a.39.39,0,0,1-.09.54A.38.38,0,0,1,5.5,22.32Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneticsOrangeIcon);
export default __webpack_public_path__ + "static/media/Genetics_Orange_Icon.3e015d08.svg";
export { ForwardRef as ReactComponent };